import {Box, useBreakpointValue, useTheme, VStack} from '@chakra-ui/react'
import {Switch} from '@legendapp/state/react'
import {Outlet} from 'react-router-dom'
import {Role} from '../../models/Role'
import '../../styles/globals.css'
import Store from '../../utils/Store'
import NavBar from './NavBar'
import {NotSupported} from './NotSupported'

const DevDatabaseBanner = () => {
  const isDevDb = Store.isDevDatabase.use()
  const isDismissed = Store.isDevBannerDismissed.use()

  if (!isDevDb || isDismissed) return null

  return (
    <Box
      position='fixed'
      bottom={0}
      right={0}
      zIndex={9999}
      overflow='hidden'
      width='150px'
      height='150px'
      pointerEvents='none'
    >
      <Box
        position='absolute'
        bottom='30px'
        right='-40px'
        bg='orange.500'
        color='white'
        px={10}
        py={1}
        fontSize='xs'
        fontWeight='bold'
        transform='rotate(-45deg)'
        textAlign='center'
        width='170px'
        boxShadow='0 2px 4px rgba(0,0,0,0.2)'
        pointerEvents='auto'
        cursor='pointer'
        onClick={() => Store.isDevBannerDismissed.set(true)}
        _hover={{opacity: 0.9}}
      >
        DEV DB
      </Box>
    </Box>
  )
}

const Layout = () => {
  const theme = useTheme()
  const role = Store.role.use()
  const isDesktop = useBreakpointValue({base: false, lg: true}, {fallback: 'lg'})
  const blockMobileViewForDancers = false && isDesktop // desactivate for now

  return (
    <>
      <VStack minH='100vh' bgColor={theme.colors.brand.background}>
        <Switch value={role}>
          {{
            [Role.SUPER_ADMIN]: () => (
              <>
                {isDesktop ? <NavBar /> : <> </>}
                {isDesktop ? <Outlet /> : <NotSupported platform='Mobile' />}
              </>
            ),
            [Role.DANCER]: () =>
              blockMobileViewForDancers ? <NotSupported platform='Desktop' /> : <Outlet />,
            default: () => <Outlet />,
          }}
        </Switch>
      </VStack>
      <DevDatabaseBanner />
    </>
  )
}

export default Layout
